var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"management-item"},[_c('div',{staticClass:"item-info"},[_vm._t("info")],2),_c('div',{staticClass:"btn-wrapper"},[_vm._t("button")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }